(function () {
    'use strict';

    var module = angular.module('uwAgenda.website');
    module.directive('websiteGeneratorFilter', ['WebsiteGeneratorService', 'OnlineBookingRoles', WebsiteGeneratorFilterFn]);

    // filter directive for multiple shared agenda selection
    function WebsiteGeneratorFilterFn(WebsiteGeneratorService, OnlineBookingRoles) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/website-generator/templates/website-generator-filter.template.html',
            scope: {
            }
        };
        return directive;
        function link(scope, element, attrs) {
            scope.selectRole = selectRole;

            // is filter collapsed or not
            scope.filterCollapsed = false;
            scope.WebsiteGeneratorService = WebsiteGeneratorService;
            scope.roles = OnlineBookingRoles;
        }
        
        function selectRole(role)
        {
            WebsiteGeneratorService.data.filterData.role = role;
            WebsiteGeneratorService.setAllPossibleLabelsUnselected();
            WebsiteGeneratorService.refreshLinks();
        }
    }
})();